import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@coval/ui"

import { GenerateTestSetConfirmationModal } from "../GenerateTestSetConfirmationModal"

interface RunResultsTableModalsProps {
  deleteCount: number
  isDeleteModalOpen: boolean
  isDeletePending: boolean
  isGenerateTestSetModalOpen: boolean
  isGeneratingTestSet: boolean
  onCloseDeleteModal: () => void
  onCloseGenerateTestSet: () => void
  onConfirmBulkDelete: () => void
  onConfirmGenerateTestSet: () => void
  selectedCount: number
}

/** The confirmations the results table's bulk actions open. */
export const RunResultsTableModals = ({
  deleteCount,
  isDeleteModalOpen,
  isDeletePending,
  isGenerateTestSetModalOpen,
  isGeneratingTestSet,
  onCloseDeleteModal,
  onCloseGenerateTestSet,
  onConfirmBulkDelete,
  onConfirmGenerateTestSet,
  selectedCount,
}: RunResultsTableModalsProps) => (
  <>
    <GenerateTestSetConfirmationModal
      isOpen={isGenerateTestSetModalOpen}
      onClose={onCloseGenerateTestSet}
      onConfirm={onConfirmGenerateTestSet}
      selectedCount={selectedCount}
      isLoading={isGeneratingTestSet}
    />

    <Dialog
      open={isDeleteModalOpen}
      onOpenChange={(open) => !open && onCloseDeleteModal()}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete Run Results</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p>
            Are you sure you want to delete {deleteCount} run result(s)? This
            action cannot be undone.
          </p>
        </DialogBody>
        <DialogFooter>
          <Button variant="secondary" onClick={onCloseDeleteModal}>
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={onConfirmBulkDelete}
            disabled={isDeletePending}
            aria-busy={isDeletePending}
          >
            Delete
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </>
)
